// DS: i1.7
import React from 'react';
import IconWrap from '../IconWrap';
const Fragments = (props)=>/*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("defs", null, /*#__PURE__*/ React.createElement("linearGradient", {
        id: "fragments-icon-gradient",
        x1: "85.39%",
        x2: "85.39%",
        y1: "-21.94%",
        y2: "107.26%"
    }, /*#__PURE__*/ React.createElement("stop", {
        offset: "0%",
        stopColor: "#FF8B78"
    }), /*#__PURE__*/ React.createElement("stop", {
        offset: "100%",
        stopColor: "#FA4A30"
    }))), /*#__PURE__*/ React.createElement("g", {
        fill: "url(#fragments-icon-gradient)",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M10.85 17.85L8.5 22l-2.35-4.15L2 15.5l4.15-2.35L8.5 9l2.35 4.15L15 15.5z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M19.45 14.45L18 17l-1.45-2.55L14 13l2.55-1.45L18 9l1.45 2.55L22 13z"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M14.13 8.13L12.5 11l-1.63-2.87L8 6.5l2.87-1.63L12.5 2l1.63 2.87L17 6.5z"
    }))));
Fragments.displayName = 'Fragments';
export default Fragments;
